class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
       if (!cartItems) {
        console.error('无法找到 cart-items 或 cart-drawer-items 元素');
        return;
    }
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    
    // const swiperNotice = swiperFun();
    // swiperNotice.init();
    
    // this.getTotalAmount();
    // 免费礼物数字框隐藏
    $('.quantity__input[data-quantity-variant-id=40987319337093]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=40987319206021]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=40987319140485]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=40992992166021]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=40997164777605]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=40997168840837]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=40997170479237]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41012071202949]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41055579504773]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41055579537541]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41057197097093]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41077611856005]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41077833662597]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41087061753989]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41087096455301]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41087095636101]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41107108298885]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41107108954245]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41107109544069]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41163590369413]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41186570338437]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=40846468481157]').prop('readonly', 'readonly').val("1").parent().hide();

    $('.quantity__input[data-quantity-variant-id=41186560966789]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41186561392773]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.quantity__input[data-quantity-variant-id=41186561491077]').prop('readonly', 'readonly').val("1").parent().hide();
    
    $('.quantity__input[data-quantity-variant-id=41243412922501]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.cart-remove-button[data-variant-id=41186560966789]').hide();
    $('.cart-remove-button[data-variant-id=41186561392773]').hide();
    $('.cart-remove-button[data-variant-id=41186561491077]').hide();

    // 隐藏手机壳赠品删除和加减数字框
    $('.cart-remove-button[data-variant-id=41314691711109]').hide();
    $('.quantity__input[data-quantity-variant-id=41314691711109]').prev().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41314691711109]').next().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41314691711109]').attr('disabled',true);

    //返校季
    $('.quantity__input[data-quantity-variant-id=41299120619653]').prop('readonly', 'readonly').val("1").parent().hide();
    $('.cart-remove-button[data-variant-id=41299120619653]').hide();

    // 隐藏杯子赠品删除和加减数字框
    $('.cart-remove-button[data-variant-id=41325946699909]').hide();
    $('.quantity__input[data-quantity-variant-id=41325946699909]').prev().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41325946699909]').next().attr('disabled',true).css('cursor','not-allowed;');
    $('.quantity__input[data-quantity-variant-id=41325946699909]').attr('disabled',true);
    
    
     var product_id = ['7076595269765','7076595433605','7076595335301','7079023968389','7079026360453','7079027310725','7096140824709','7096524865669','7109015961733','7109037064325','7109036671109','7115754012805','7115754602629','7115755225221'
                      ,'7135729451141'];
     var gift_id = ['7078331973765']
     var superGiftSyp_id = ['7084151636101']
     var discountCardId = ['7106034696325']
     var discountCardIdAllYear = ['7106067038341']
     var loklikMachine = ['7142754779269']
     var newGift = ['7161495060613']
     var cartContents = fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        var cartArr = [];
        var cartList = data.items;    
        var finalTotalPrice = data.total_price / 100;
        const GIFT_A_ID = 41186560966789;  //  $229
        const GIFT_B_ID = 41186561392773;  // $339
        const GIFT_C_ID = 41186561491077; // $569
        const GIFT_D_ID = 41299120619653  // $359

        const Phone_Cases_ID = 41314691711109;
        const PhoneCasesIdsToCheck = [41255273889925, 41255273922693, 41257574531205,41255271366789,41255271399557,41257574563973,41255271465093,41255271497861,41257574596741,41255271563397,41255271596165,41257574629509,41255274840197,41255274872965,41255274905733];

        const Cup_ID = 41325946699909;
        const CupIdsToCheck = [41325944111237, 41325944144005, 41325944209541,41325944242309,41325944930437,41325944963205,41325944307845,41325944340613,41325944406149,41325944438917]
        
        let PhoneCasesTotalQuantity = 0;
        let hasPhoneCase = false;
        let phoneCaseQuantity = 0;
        
        let CupTotalQuantity = 0;
        let hasCup = false;
        let CupQuantity = 0;

        let hasGiftA = false;
        let hasGiftB = false;
        let hasGiftC = false;
        let hasGiftD = false;
        

      //  if (cartList.length > 0) {
      //     cartList.forEach((item) => {
      //       cartArr.push(item.product_id);
      //       if (item.id === GIFT_A_ID) hasGiftA = true;
      //       if (item.id === GIFT_B_ID) hasGiftB = true;
      //       if (item.id === GIFT_C_ID) hasGiftC = true;
      //       if (item.id === GIFT_D_ID) hasGiftD = true;
      //       if (PhoneCasesIdsToCheck.includes(item.id)) {
      //         PhoneCasesTotalQuantity += item.quantity || 0; // 安全处理undefined情况
      //       }
      //       // 检查购物车是否已包含Phone_Cases_ID
      //       if (item.id === Phone_Cases_ID) {
      //         hasPhoneCase = true;
      //         phoneCaseQuantity = item.quantity;
      //       }
      //       if (CupIdsToCheck.includes(item.id)) {
      //         CupTotalQuantity += item.quantity || 0; // 安全处理undefined情况
      //       }
      //        // 检查购物车是否已包含Cup_ID
      //       if (item.id === Cup_ID) {
      //         hasCup = true;
      //         CupQuantity = item.quantity;
      //       }
      //     });
      //   }
      //     // 合并删除操作对象
      //     const delOperations = {};
      //     // 合并添加操作数组
      //     const addItems = [];
        
      //     //返校季活动代码
      //      if (finalTotalPrice < 359 && hasGiftD) {
      //       Object.assign(delOperations, {
      //         [GIFT_D_ID]: 0
      //       });
      //     } 
      //     else if (finalTotalPrice >= 359) {
      //       if (!hasGiftD) addItems.push({ id: GIFT_D_ID, quantity: 1 });
      //     }

          // 第一阶段：处理赠品逻辑
          // if (finalTotalPrice < 229 && (hasGiftA || hasGiftB || hasGiftC)) {
          //   Object.assign(delOperations, {
          //     [GIFT_A_ID]: 0,
          //     [GIFT_B_ID]: 0,
          //     [GIFT_C_ID]: 0
          //   });
          // } 
          // else if (finalTotalPrice >= 229) {
          //   // 条件1: 229-339区间
          //   if (finalTotalPrice < 339) {
          //     if (hasGiftB) delOperations[GIFT_B_ID] = 0;
          //     else if (hasGiftC) delOperations[GIFT_C_ID] = 0;
          //     if (!hasGiftA) addItems.push({ id: GIFT_A_ID, quantity: 1 });
          //   }
          //   // 条件2: 339-569区间
          //   else if (finalTotalPrice < 569) {
          //     if (hasGiftA) delOperations[GIFT_A_ID] = 0;
          //     else if (hasGiftC) delOperations[GIFT_C_ID] = 0;
          //     if (!hasGiftB) addItems.push({ id: GIFT_B_ID, quantity: 1 });
          //   }
          //   // 条件3: ≥569
          //   else {
          //     if (hasGiftA) delOperations[GIFT_A_ID] = 0;
          //     else if (hasGiftB) delOperations[GIFT_B_ID] = 0;
          //     if (!hasGiftC) addItems.push({ id: GIFT_C_ID, quantity: 1 });
          //   }
          // }
        
        //   // 第二阶段：处理手机壳数量同步
        //   if (PhoneCasesTotalQuantity >= 0) {
        //     const currentQuantity = hasPhoneCase ? phoneCaseQuantity : 0;
        //     if (PhoneCasesTotalQuantity > currentQuantity) {
        //       addItems.push({
        //         id: Phone_Cases_ID,
        //         quantity: PhoneCasesTotalQuantity - currentQuantity
        //       });
        //     }
        //     else if (PhoneCasesTotalQuantity !== 0 && PhoneCasesTotalQuantity < currentQuantity) {
        //       delOperations[Phone_Cases_ID] = currentQuantity - PhoneCasesTotalQuantity;
        //     }
        //     else if (PhoneCasesTotalQuantity === 0 && hasPhoneCase) {
        //       delOperations[Phone_Cases_ID] = 0;
        //     }
        //   }
    
        //   // 第三阶段：处理杯子数量同步
        //   if (CupTotalQuantity >= 0) {
        //     const currentCupQuantity = hasCup ? CupQuantity : 0;
        //     if (CupTotalQuantity > currentCupQuantity) {
        //       addItems.push({
        //         id: Cup_ID,
        //         quantity: CupTotalQuantity - currentCupQuantity
        //       });
        //     }
        //     else if (CupTotalQuantity !== 0 && CupTotalQuantity < currentCupQuantity) {
        //       delOperations[Cup_ID] = currentCupQuantity - CupTotalQuantity;
        //     }
        //     else if (CupTotalQuantity === 0 && hasCup) {
        //       delOperations[Cup_ID] = 0;
        //     }
        //   }
        
        //   // 批量执行操作
        //   if (Object.keys(delOperations).length > 0) {
        //     this.clearcart(delOperations);
        //   }
        //   if (addItems.length > 0) {
        //     this.addCart({ items: addItems });
        //   }

        
        // // 一些购物车的处理
        // if(data.item_count > 0){
        //  $('.cart-count-amount>span:nth-child(1)').text(data.item_count)
        // }else{
        //   $('.cart-count-amount').hide();
        // }
        // $('.drawer__heading>.total').text(`${data.item_count} items`)
        // if(data.original_total_price){
        //   var originalTotalPrice = data.original_total_price / 100;
        //   $('s[data-cart-total]').children().text('$'+originalTotalPrice);
        // }
        // $('.total_value>span').text('$'+finalTotalPrice)
        // $('#item_count').text(data.item_count+' items')
        // if(finalTotalPrice == 0){
        //   $('.cart__checkout-button button').attr('disabled','true')
        // }

      const commonElements = product_id.filter(item => cartArr.some(otherItem => otherItem == item));
      const giftElements = gift_id.filter(item => cartArr.some(otherItem => otherItem == item));
      const sypElements = superGiftSyp_id.filter(item => cartArr.some(otherItem => otherItem == item));
      const discountElements = discountCardId.filter(item => cartArr.some(otherItem => otherItem == item));
      const discountAllYearElements = discountCardIdAllYear.filter(item => cartArr.some(otherItem => otherItem == item));
      const loklikMachineElements = loklikMachine.filter(item => cartArr.some(otherItem => otherItem == item));
      const newGiftElements = newGift.filter(item => cartArr.some(otherItem => otherItem == item));
        if(commonElements && commonElements.length > 0){
         $('.auto2-free-gift .product-form__submit').attr('disabled',true);
         $("#auto2-free-gift-tips").show();
          $('#updates_7076595269765').hide();
          $('#updates_7076595433605').hide();
          $('#updates_7076595335301').hide();
          $('#updates_7079023968389').hide();
          $('#updates_7079026360453').hide();
          $('#updates_7079027310725').hide();
          $('#updates_7096140824709').hide();
          $('#updates_7135729451141').hide();
          $('.product div[data-id="7096140824709"] #reset_button,.product div[data-id="7135729451141"] #reset_button').show().attr('disabled', true);
          $('.product div[data-id="7096140824709"] .product-form__off,.product div[data-id="7135729451141"] .product-form__off').show();
          $('.product div[data-id="7096140824709"] .product-form__off,.product div[data-id="7135729451141"] .product-form__off').text('Max 1 free gift or deposit per order.');
            setTimeout(function(){
               $('#cart_recom1_7096140824709.product-form__submit,#updates_7096140824709.product-form__submit,#cart_recom1_7076595269765.product-form__submit,#cart_recom1_7076595433605.product-form__submit,#cart_recom1_7076595335301.product-form__submit,#cart_recom1_7079023968389.product-form__submit,#cart_recom1_7079026360453.product-form__submit,#cart_recom1_7079027310725.product-form__submit,#cart_recom1_7096524865669.product-form__submit,#cart_recom1_7109015961733.product-form__submit,#cart_recom1_7109037064325.product-form__submit,#cart_recom1_7109036671109.product-form__submit,#cart_recom1_7135729451141.product-form__submit').attr('disabled', true);
            },1000);
      }else{
         $('.auto2-free-gift .product-form__submit').attr('disabled',false);
         $('.auto2-free-gift .product-form__submit').children('.t').each(function(){
         if($(this).text().indexOf('Sold out') != -1){  
           $(this).parent('.product-form__submit').attr('disabled',true);
          }
        })
         $("#auto2-free-gift-tips").hide();
          $('#updates_7076595269765').show();
          $('#updates_7076595433605').show();
          $('#updates_7076595335301').show();
          $('#updates_7079023968389').show();
          $('#updates_7079026360453').show();
          $('#updates_7079027310725').show();
          $('#updates_7096140824709').show();
          $('#updates_7135729451141').show().attr('disabled', false);
          $('.product div[data-id="7096140824709"] #reset_button,.product div[data-id="7135729451141"] #reset_button').hide().attr('disabled', false);
          $('.product div[data-id="7096140824709"] .product-form__off,.product div[data-id="7135729451141"] .product-form__off').hide();
            setTimeout(function(){
               $('#cart_recom1_7096140824709.product-form__submit,#updates_7096140824709.product-form__submit,#cart_recom1_7076595269765.product-form__submit,#cart_recom1_7076595433605.product-form__submit,#cart_recom1_7076595335301.product-form__submit,#cart_recom1_7079023968389.product-form__submit,#cart_recom1_7079026360453.product-form__submit,#cart_recom1_7079027310725.product-form__submit,#cart_recom1_7096524865669.product-form__submit,#cart_recom1_7109015961733.product-form__submit,#cart_recom1_7109037064325.product-form__submit,#cart_recom1_7109036671109.product-form__submit,#cart_recom1_7135729451141.product-form__submit').attr('disabled', false);
            },1000);
      }
      if(giftElements && giftElements.length > 0){
        $('.auto2-form-addtocart .product-form__submit').attr('disabled', true);
        $('.auto2-form-dialog-model-tips').show();
      }else{
        $('.auto2-form-addtocart .product-form__submit').attr('disabled', false);
        $('.auto2-form-dialog-model-tips').hide();
      }
      if(sypElements && sypElements.length > 0){
         $('.auto2-dialog-addcart .product-form__submit').attr('disabled',true);
         $(".auto2-claim-now-tips").show();
      }else{
         $('.auto2-dialog-addcart .product-form__submit').attr('disabled',false);
         $(".auto2-claim-now-tips").hide();
      }
      if(discountElements  && discountElements.length > 0){
          $('.new-year-bundle #campaign_7106034696325').attr('disabled',true);
          $('#updates_7106034696325').hide();
          $('.product div[data-id="7106034696325"] #reset_button').show().attr('disabled', true);
          $('.product div[data-id="7106034696325"] .product-form__off').show();
          $('.product div[data-id="7106034696325"] .product-form__off').text('* Already have one in your cart');
            setTimeout(function(){
               $('#cart_recom1_7106034696325.product-form__submit,#updates_7106034696325.product-form__submit').attr('disabled', true);
            },1000);
      }else{
          $('.new-year-bundle #campaign_7106034696325').attr('disabled',false);
          $('#updates_7106034696325').show();
          $('.product div[data-id="7106034696325"] #reset_button').hide().attr('disabled', false);
          $('.product div[data-id="7106034696325"] .product-form__off').hide();
            setTimeout(function(){
               $('#cart_recom1_7106034696325.product-form__submit,#updates_7106034696325.product-form__submit').attr('disabled', false);
            },1000);
      }
      if(discountAllYearElements  && discountAllYearElements.length > 0){
       $('.new-year-bundle #campaign_7106067038341').attr('disabled',true);
        $('#updates_7106067038341').hide();
        $('.product div[data-id="7106067038341"] #reset_button').show().attr('disabled', true);
        $('.product div[data-id="7106067038341"] .product-form__off').show();
        $('.product div[data-id="7106067038341"] .product-form__off').text('* Already have one in your cart');
          setTimeout(function(){
             $('#cart_recom1_7106067038341.product-form__submit,#updates_7106067038341.product-form__submit').attr('disabled', true);
          },1000);
      }else{
         $('.new-year-bundle #campaign_7106067038341').attr('disabled',false);
          $('#updates_7106067038341').show();
          $('.product div[data-id="7106067038341"] #reset_button').hide().attr('disabled', false);
          $('.product div[data-id="7106067038341"] .product-form__off').hide();
            setTimeout(function(){
               $('#cart_recom1_7106067038341.product-form__submit,#updates_7106067038341.product-form__submit').attr('disabled', false);
            },1000);
      }
        
      if (loklikMachineElements && loklikMachineElements.length > 0) {
          $('.iengtave-deposite-button .product-form__submit').attr('disabled', true);
          $('.iengtave-deposite-tips').show();
          $('#updates_7049217114245,#updates_7142754779269').hide();
          $('.product div[data-id="7049217114245"] #reset_button.product div[data-id="7142754779269"] #reset_button').show().attr('disabled', true);
          $('.product div[data-id="7049217114245"] .product-form__off.product div[data-id="7142754779269"] .product-form__off').show();
          $('.product div[data-id="7049217114245"] .product-form__off.product div[data-id="7142754779269"] .product-form__off').text('* Already have one in your cart');
          setTimeout(function () {
              $('#cart_recom1_7049217114245.product-form__submit,#updates_7049217114245.product-form__submit,#cart_recom1_7142754779269.product-form__submit,#updates_7142754779269.product-form__submit').attr('disabled', true);
          }, 1000);
      } else {
          $('.iengtave-deposite-button .product-form__submit').attr('disabled', false);
          $('.iengtave-deposite-tips').hide();
          $('#updates_7049217114245,#updates_7142754779269').show();
          $('.product div[data-id="7049217114245"] #reset_button,.product div[data-id="7142754779269"] #reset_button').hide().attr('disabled', false);
          $('.product div[data-id="7049217114245"] .product-form__off,.product div[data-id="7142754779269"] .product-form__off').hide();
          setTimeout(function () {
              $('#cart_recom1_7049217114245.product-form__submit,#updates_7049217114245.product-form__submit,#cart_recom1_7142754779269.product-form__submit,#updates_7142754779269.product-form__submit').attr('disabled', false);
          }, 1000);
      }
     
      if (newGiftElements && newGiftElements.length > 0) {
          $('#updates_7161495060613').hide();
          $('.product div[data-id="7161495060613"] #reset_button.product div[data-id="7142754779269"] #reset_button').show().attr('disabled', true);
          $('.product div[data-id="7161495060613"] .product-form__off.product div[data-id="7142754779269"] .product-form__off').show();
          $('.product div[data-id="7161495060613"] .product-form__off.product div[data-id="7142754779269"] .product-form__off').text('* Already have one in your cart');
          setTimeout(function () {
              $('#cart_recom1_7161495060613.product-form__submit,#updates_7161495060613.product-form__submit').attr('disabled', true);
          }, 1000);
      } else {
          $('#updates_7161495060613').show();
          $('.product div[data-id="7161495060613"] #reset_button,.product div[data-id="7142754779269"] #reset_button').hide().attr('disabled', false);
          $('.product div[data-id="7161495060613"] .product-form__off,.product div[data-id="7142754779269"] .product-form__off').hide();
          setTimeout(function () {
              $('#cart_recom1_7161495060613.product-form__submit,#updates_7161495060613.product-form__submit').attr('disabled', false);
          }, 1000);
      }
        return data;
      });
  }

  clearcart(updates) {
    $('#CartDrawer .drawer__inner').addClass('cart-drawer-loading');
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
    .then((response) => {
      return response.json();
    })
    .then(() => {
      this.onCartUpdate(); // 调用onCartUpdate方法刷新购物车抽屉式面板
       $('#CartDrawer .drawer__inner').removeClass('cart-drawer-loading');
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  }
  addCart(updates) {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
    })
    .then(response => {
        return response.json();
    })
    .then(() => {
      this.onCartUpdate(); // 调用onCartUpdate方法刷新购物车抽屉式面板
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  }
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Drawer-quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';
    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }
    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    if(event.target.name == "note"){
      return
    }
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cartDrawer-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.querySelector('.cart_drawer_totals');
        
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cartDrawer-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        
        // 总金额变化 进度条变化 start
        /*var totalNumber = Number(parsedState.total_price) / 100;
        var progressBar = document.querySelector('.progress-bar');
        var percentage = (totalNumber / 80) * 100;
        progressBar.style.width = `${percentage}%`;*/
        // 总金额变化 进度条变化 end

      })
      .catch((error) => {
         console.error('Error updating cart quantity:', error);
        // this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        // const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        // errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
    
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    //console.log(html,selector)
    // const parser = new DOMParser();
    // const doc = parser.parseFromString(html, 'text/html');
    // const element = doc.querySelector(selector);
    
    // if (element) {
    //     return element.innerHTML;
    // } else {
    //     console.error('Element not found:', selector);
    //     return ''; // 或者返回其他适当的默认值
    // }
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.querySelector('.CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.querySelector('.CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
